import { IRootState } from '../../common/stores/rootState';
import artifactStore from '../../common/stores/artifactStore';
import embeddableStore from './embeddableStore';
import { ModuleTree } from 'vuex';

const stores = {
  artifactStore,
  embeddableStore
} as ModuleTree<IRootState>;

export * from '../../common/stores/rootState';
export * from '../../common/stores/artifactStore';
export * from './embeddableStore';
export { stores, artifactStore, embeddableStore };
export default stores;
